var _classCallCheck = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _debug = require('debug');

var AWS = require('aws-sdk');

var CloudWatchEventFormatter = require('./cloudwatch-event-formatter');

var debug = _debug('winston-aws-cloudwatch:CloudWatchClient');

var DEFAULT_OPTIONS = {
  awsConfig: null,
  formatLog: null,
  formatLogItem: null,
  createLogGroup: false,
  createLogStream: false,
  submissionRetryCount: 1
};

var CloudWatchClient =
/*#__PURE__*/
function () {
  "use strict";

  function CloudWatchClient(logGroupName, logStreamName, options) {
    _classCallCheck(this, CloudWatchClient);

    debug('constructor', {
      logGroupName: logGroupName,
      logStreamName: logStreamName,
      options: options
    });
    this._logGroupName = logGroupName;
    this._logStreamName = logStreamName;
    this._options = Object.assign({}, DEFAULT_OPTIONS, options);
    this._formatter = new CloudWatchEventFormatter(this._options);
    this._sequenceToken = null;
    this._client = new AWS.CloudWatchLogs(this._options.awsConfig);
    this._initializing = null;
  }

  _createClass(CloudWatchClient, [{
    key: "submit",
    value: function submit(batch) {
      var _this = this;

      debug('submit', {
        batch: batch
      });
      return this._initialize().then(function () {
        return _this._doSubmit(batch, 0);
      });
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      var _this2 = this;

      if (this._initializing == null) {
        this._initializing = this._maybeCreateLogGroup().then(function () {
          return _this2._maybeCreateLogStream();
        });
      }

      return this._initializing;
    }
  }, {
    key: "_maybeCreateLogGroup",
    value: function _maybeCreateLogGroup() {
      var _this3 = this;

      if (!this._options.createLogGroup) {
        return Promise.resolve();
      }

      var params = {
        logGroupName: this._logGroupName
      };
      return this._client.createLogGroup(params).promise().catch(function (err) {
        return _this3._allowResourceAlreadyExistsException(err);
      });
    }
  }, {
    key: "_maybeCreateLogStream",
    value: function _maybeCreateLogStream() {
      var _this4 = this;

      if (!this._options.createLogStream) {
        return Promise.resolve();
      }

      var params = {
        logGroupName: this._logGroupName,
        logStreamName: this._logStreamName
      };
      return this._client.createLogStream(params).promise().catch(function (err) {
        return _this4._allowResourceAlreadyExistsException(err);
      });
    }
  }, {
    key: "_allowResourceAlreadyExistsException",
    value: function _allowResourceAlreadyExistsException(err) {
      return err.code === 'ResourceAlreadyExistsException' ? Promise.resolve() : Promise.reject(err);
    }
  }, {
    key: "_doSubmit",
    value: function _doSubmit(batch, retryCount) {
      var _this5 = this;

      return this._maybeUpdateSequenceToken().then(function () {
        return _this5._putLogEventsAndStoreSequenceToken(batch);
      }).catch(function (err) {
        return _this5._handlePutError(err, batch, retryCount);
      });
    }
  }, {
    key: "_maybeUpdateSequenceToken",
    value: function _maybeUpdateSequenceToken() {
      return this._sequenceToken != null ? Promise.resolve() : this._fetchAndStoreSequenceToken();
    }
  }, {
    key: "_handlePutError",
    value: function _handlePutError(err, batch, retryCount) {
      if (err.code !== 'InvalidSequenceTokenException') {
        return Promise.reject(err);
      }

      if (retryCount >= this._options.submissionRetryCount) {
        var error = new Error('Invalid sequence token, will retry');
        error.code = 'InvalidSequenceTokenException';
        return Promise.reject(error);
      }

      this._sequenceToken = null;
      return this._doSubmit(batch, retryCount + 1);
    }
  }, {
    key: "_putLogEventsAndStoreSequenceToken",
    value: function _putLogEventsAndStoreSequenceToken(batch) {
      var _this6 = this;

      return this._putLogEvents(batch).then(function (_ref) {
        var nextSequenceToken = _ref.nextSequenceToken;
        return _this6._storeSequenceToken(nextSequenceToken);
      });
    }
  }, {
    key: "_putLogEvents",
    value: function _putLogEvents(batch) {
      var _this7 = this;

      var sequenceToken = this._sequenceToken;
      debug('putLogEvents', {
        batch: batch,
        sequenceToken: sequenceToken
      });
      var params = {
        logGroupName: this._logGroupName,
        logStreamName: this._logStreamName,
        logEvents: batch.map(function (item) {
          return _this7._formatter.formatLogItem(item);
        }),
        sequenceToken: sequenceToken
      };
      return this._client.putLogEvents(params).promise();
    }
  }, {
    key: "_fetchAndStoreSequenceToken",
    value: function _fetchAndStoreSequenceToken() {
      var _this8 = this;

      debug('fetchSequenceToken');
      return this._findLogStream().then(function (_ref2) {
        var uploadSequenceToken = _ref2.uploadSequenceToken;
        return _this8._storeSequenceToken(uploadSequenceToken);
      });
    }
  }, {
    key: "_storeSequenceToken",
    value: function _storeSequenceToken(sequenceToken) {
      debug('storeSequenceToken', {
        sequenceToken: sequenceToken
      });
      this._sequenceToken = sequenceToken;
      return sequenceToken;
    }
  }, {
    key: "_findLogStream",
    value: function _findLogStream(nextToken) {
      var _this9 = this;

      debug('findLogStream', {
        nextToken: nextToken
      });
      var params = {
        logGroupName: this._logGroupName,
        logStreamNamePrefix: this._logStreamName,
        nextToken: nextToken
      };
      return this._client.describeLogStreams(params).promise().then(function (_ref3) {
        var logStreams = _ref3.logStreams,
            nextToken = _ref3.nextToken;
        var match = logStreams.find(function (_ref4) {
          var logStreamName = _ref4.logStreamName;
          return logStreamName === _this9._logStreamName;
        });

        if (match) {
          return match;
        }

        if (nextToken == null) {
          throw new Error('Log stream not found');
        }

        return _this9._findLogStream(nextToken);
      });
    }
  }]);

  return CloudWatchClient;
}();

module.exports = CloudWatchClient;